"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdsListResponseToJSON = exports.AdsListResponseFromJSONTyped = exports.AdsListResponseFromJSON = exports.instanceOfAdsListResponse = void 0;
var runtime_1 = require("../runtime");
var AdResponse_1 = require("./AdResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the AdsListResponse interface.
 */
function instanceOfAdsListResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdsListResponse = instanceOfAdsListResponse;
function AdsListResponseFromJSON(json) {
    return AdsListResponseFromJSONTyped(json, false);
}
exports.AdsListResponseFromJSON = AdsListResponseFromJSON;
function AdsListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'ads': !(0, runtime_1.exists)(json, 'ads') ? undefined : (json['ads'].map(AdResponse_1.AdResponseFromJSON)),
    };
}
exports.AdsListResponseFromJSONTyped = AdsListResponseFromJSONTyped;
function AdsListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'ads': value.ads === undefined ? undefined : (value.ads.map(AdResponse_1.AdResponseToJSON)),
    };
}
exports.AdsListResponseToJSON = AdsListResponseToJSON;
